import s from "./LoadingSpinnerWrapper.module.scss";
import { PropsWithChildren } from "react";

export const LoadingSpinnerWrapper = ({
  children,
  isLoading = false,
}: PropsWithChildren<{
  isLoading?: boolean;
}>) => {
  if (!isLoading) return <>{children}</>;
  return (
    <div className={s.wrapper}>
      <div className={s.spinner}>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};
